import { Box, Typography } from '@mui/material'

interface ECGTechnicalInfoProps {
  durationSeconds: number
  heartRate?: number
  showBorder?: boolean
  bpm?: number
}

/**
 * Componente de informações técnicas para visualização de ECG
 * Exibe informações sobre velocidade, tempo, voltagem, duração e frequência cardíaca
 */
export const ECGTechnicalInfo = ({
  durationSeconds,
  heartRate,
  showBorder = true,
  bpm
}: ECGTechnicalInfoProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1,
        bgcolor: 'background.default',
        color: 'text.secondary',
        borderTop: showBorder ? '1px solid' : 'none',
        borderColor: 'divider',
        fontFamily: 'monospace',
        gap: { xs: 0, sm: 2 },
        flexWrap: 'wrap'
      }}
    >
      <Typography variant='caption'>
        <strong>Quadrado menor = 1mm</strong>
      </Typography>
      <Typography variant='caption'>
        <strong>Quadrado maior = 5mm</strong>
      </Typography>
      <Typography variant='caption'>
        Velocidade: <strong>25 mm/s</strong>
      </Typography>
      <Typography variant='caption'>
        Voltagem: <strong>1mm = 0,1mV</strong> | <strong>10mm = 1mV</strong>
      </Typography>
      <Typography variant='caption'>
        Duração: <strong>{durationSeconds}s</strong>
      </Typography>
      {heartRate && (
        <Typography variant='caption'>
          FC Média: <strong>{heartRate}bpm</strong>
        </Typography>
      )}
      {!heartRate && (
        <Typography variant='caption'>
          {/* FC Média exibida a partir da prop bpm quando heartRate não está disponível */}
          FC Média: <strong>{bpm ?? 0}bpm</strong>
        </Typography>
      )}
    </Box>
  )
}
